import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/default.jpg'


const _hoisted_1 = { class: "font-bold text-center mb-5" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "bg-green-300 h-60 mt-4 flex flex-col space-y-5 justify-center items-center" }
const _hoisted_4 = { class: "heading" }
const _hoisted_5 = { class: "flex flex-col md:flex-row mt-4" }
const _hoisted_6 = {
  id: "img-symp",
  class: "px-1 md:px-4 w-screen md:w-1/4 md:flex-shrink-0"
}
const _hoisted_7 = { id: "img" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["alt"]
const _hoisted_10 = {
  id: "symp",
  class: "mt-4"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-center my-5" }, "Symptoms", -1)
const _hoisted_12 = {
  key: 0,
  class: "mb-0 md:mb-5 flex flex-wrap gap-3 justify-center items-center"
}
const _hoisted_13 = {
  key: 1,
  class: "text-sm text-center"
}
const _hoisted_14 = {
  id: "comments",
  class: "md:flex-grow p-6"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-center md:text-left" }, "Comments", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "font-bold text-sm" }
const _hoisted_18 = { class: "flex justify-between py-2" }
const _hoisted_19 = {
  key: 0,
  class: "text-justify w-11/12"
}
const _hoisted_20 = {
  key: 1,
  class: "text-justify w-11/12"
}
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "mr-0 md:mr-10" }
const _hoisted_23 = { class: "text-sm text-blue-500" }
const _hoisted_24 = {
  key: 1,
  class: "py-3 text-center md:text-left text-sm"
}
const _hoisted_25 = { class: "flex" }
const _hoisted_26 = { class: "m-2" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Loading")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Add")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_GoBack = _resolveComponent("GoBack")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_ImageModal = _resolveComponent("ImageModal")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_comment = _resolveComponent("a-comment")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_GoBack),
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.allergy.name), 1),
    (_ctx.allergy.name)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("section", _hoisted_3, [
            _createVNode(_component_a_progress, {
              type: "circle",
              percent: _ctx.mapSeverity[_ctx.allergy.severity]
            }, null, 8, ["percent"]),
            _createElementVNode("h2", _hoisted_4, "Severity: " + _toDisplayString(_ctx.allergy.severity), 1)
          ]),
          _createElementVNode("main", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_ctx.allergy.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.allergy.image,
                      alt: _ctx.allergy.name,
                      class: "w-full h-60 object-cover cursor-pointer",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args)))
                    }, null, 8, _hoisted_8))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _imports_0,
                      alt: _ctx.allergy.name,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args))),
                      class: "w-full h-60 object-cover cursor-pointer"
                    }, null, 8, _hoisted_9)),
                _createVNode(_component_ImageModal, {
                  visible: _ctx.visible,
                  "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
                  allergyImage: _ctx.allergy.image,
                  allergyName: _ctx.allergy.name,
                  handleOk: _ctx.handleOk
                }, null, 8, ["visible", "allergyImage", "allergyName", "handleOk"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                (_ctx.allergy.symptoms.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allergy.symptoms, (symptoms) => {
                        return (_openBlock(), _createElementBlock("div", { key: symptoms }, [
                          _createVNode(_component_Chip, { textToRender: symptoms }, null, 8, ["textToRender"])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_13, " No symptoms have been added for this allergy yet. "))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              (_ctx.allergy.comments.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allergy.comments, (comment) => {
                      return (_openBlock(), _createBlock(_component_a_comment, { key: comment }, {
                        avatar: _withCtx(() => [
                          _createVNode(_component_a_avatar, {
                            src: "https://joeschmoe.io/api/v1/random",
                            alt: comment.addedBy.name
                          }, null, 8, ["alt"])
                        ]),
                        author: _withCtx(() => [
                          _createElementVNode("p", _hoisted_17, _toDisplayString(comment.addedBy.name), 1)
                        ]),
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_18, [
                            (comment.comment.length > 500 && !_ctx.seeMore)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                                  _createTextVNode(_toDisplayString(comment.comment.substring(0, 500)) + " ", 1),
                                  _createElementVNode("span", {
                                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSee && _ctx.handleSee(...args))),
                                    class: "text-pink-500 cursor-pointer"
                                  }, "see more")
                                ]))
                              : (comment.comment.length > 500 && _ctx.seeMore)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                                    _createTextVNode(_toDisplayString(comment.comment.substring(0, comment.comment.length)) + " ", 1),
                                    _createElementVNode("span", {
                                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSee && _ctx.handleSee(...args))),
                                      class: "text-pink-500 cursor-pointer"
                                    }, "see less")
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(comment.comment), 1)),
                            _createElementVNode("div", _hoisted_22, [
                              (_ctx.currentUser === comment.addedBy.id)
                                ? (_openBlock(), _createBlock(_component_DeleteOutlined, {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.deleteComment(comment))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        datetime: _withCtx(() => [
                          _createVNode(_component_a_tooltip, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.dayjs(comment.createdAt).fromNow()), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_24, " You can add comments regarding the allergy here. ")),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_a_form_item, {
                  name: "comment",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      class: "",
                      value: _ctx.comment,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.comment) = $event)),
                      placeholder: "add your comment",
                      "allow-clear": ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_26, [
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "primary",
                        class: "",
                        loading: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_27
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        type: "primary",
                        onClick: _ctx.addComment
                      }, {
                        default: _withCtx(() => [
                          _hoisted_28
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_Loading, { key: 1 }))
  ], 64))
}